import { render, staticRenderFns } from "./TermlyWrapper.vue?vue&type=template&id=7a5e5bba"
import script from "./TermlyWrapper.vue?vue&type=script&lang=js"
export * from "./TermlyWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports